import React from 'react';
import CardsContent from "./cards-content.jsx";
import AlarmTypesContent from "./alarm-types-content.jsx";
import AlarmSourceContent from "./alarm-source-content.jsx";
import AlarmQuestionsContent from "./alarm-questions-content.jsx";
import VehiclePointsContent from "./vehicle-points-content.jsx";

const GeneralContent = ({ data, collapsed }) => {
    return (
        <>
            <div id="general">

                <div className="report-divisor mb-6">
                    <span className="divisor-title">
                        VISÃO GERAL
                    </span>
                </div>

                <CardsContent key={`cards-${collapsed}`} data={data}/>
                <AlarmTypesContent key={`types-${collapsed}`} data={data}/>
                <AlarmSourceContent key={`origin-${collapsed}`} data={data}/>
                <AlarmQuestionsContent key={`questions-${collapsed}`} data={data}/>
                <VehiclePointsContent key={`vehicle-points-${collapsed}`} data={data}/>

            </div>
        </>
    );
};

export default GeneralContent;